import React, { useState, useEffect } from "react";
import { View, StyleSheet, TouchableOpacity, Text, Platform } from "react-native";
import AppTheme from "../../AppTheme";

const WEEK = ["M", "T", "W", "T", "F", "Sa", "Su"];

export default function ResolutionWeekDays({
  weekdays = "1111111",
  onSelectedChange = () => {},
}) {
  const [week, setWeek] = useState([]);

  useEffect(() => {
    let selectedWeekdays = weekdays.split("");
    const days = WEEK.map((d, index) => {
      return {
        index: index,
        name: d,
        isSelected: selectedWeekdays[index] != 0,
      };
    });

    setWeek(days);
  }, [weekdays]);

  const toggleSelection = (day) => {
    // Toggle selected day
    week.forEach((wd, index) => {
      if (day.index == index) wd.isSelected = !wd.isSelected;
    });

    setWeek([...week]);

    // Update goal
    const selected_weekdays = week.map((d) => (d.isSelected ? 1 : 0));
    onSelectedChange(selected_weekdays.join(""));
  };

  return (
    <View style={styles.container}>
      {week.map((day, i) => {
        return (
          <TouchableOpacity
            onPress={() => toggleSelection(day)}
            key={i}
            style={[
              styles.day,
              {
                backgroundColor: day.isSelected
                  ? AppTheme.DEFAULT_COLOR
                  : "#F4F6FA",
              },
            ]}
          >
            <Text
              style={[
                styles.dayText,
                { color: day.isSelected ? "#FFF" : AppTheme.DEFAULT_COLOR },
              ]}
            >
              {day.name}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
  },
  day: {
    width: 30,
    height: 30,
    borderRadius: 22,
    backgroundColor: "#F4F6FA",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 2,
  },
  dayText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: "#FFF",
  },
});
